import React from "react";
import classNames from "classnames";
import * as icons from "./Icons";
import styles from "./Icon.module.css";

const DefaultIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const Icon = ({
  name,
  className,
  size = 24,
  inverse = false,
  ...props
}) => {
  if (!name) {
    console.warn("Icon component: name prop is required");
    return null;
  }

  const iconKey = `${name[0].toUpperCase()}${name.slice(1)}Icon`;
  const Element = icons[iconKey] || DefaultIcon;

  if (!icons[iconKey]) {
    console.warn(`Icon component: Icon "${name}" not found, using default`);
  }

  return (
    <div
      className={classNames(styles.icon, styles[`icon-${size}`], className, {
        [styles.iconInverse]: inverse,
      })}
    >
      <Element className={styles.iconSvg} {...props} />
    </div>
  );
};
